// @flow

export class IOError extends Error {
    cause: ?string;
    constructor(msg?:?string=undefined, cause?:?string=undefined) {
        super(msg);
        this.cause = cause;
    }
}
